import { GET_ALL_REPORTS_SUCCESS } from './';

export default payload => ({
  type: GET_ALL_REPORTS_SUCCESS,
  payload,
});
